import { render, staticRenderFns } from "./UserLinkProviderDialog.vue?vue&type=template&id=049931fc&scoped=true"
import script from "./UserLinkProviderDialog.vue?vue&type=script&lang=js"
export * from "./UserLinkProviderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049931fc",
  null
  
)

export default component.exports